import Styles from './MobileGenerationAndQuestionnaire.module.scss'
import cx from 'classnames'

interface StepsHeaderProps {
  currentStep: number
  totalSteps: number
}

export const StepsHeader = ({ currentStep, totalSteps }: StepsHeaderProps) => {
  return (
    <div className={Styles.steps}>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div key={index} className={cx(Styles.step, { [Styles.active]: index === currentStep })} />
      ))}
    </div>
  )
}
